import React from "react";
import SignupLeft from "./SIgnupLeft";
import SignupRight from "./SignupRight";
import './signupStyles/signupStyle.css';

const Signup: React.FC = () => {
    return (
        <div className="h-[80%] lg:w-[70%] w-[90%] flex justify-center m-auto bg-orange-300">
            <SignupLeft />
            <SignupRight />
        </div>
    )
}
export default Signup;